import actions from "./actions";

const {
    FETCH_SALARY_DECLARATIONS_ATTENDANCE,
    FETCH_MONTHLY_SALARIES,
    FETCH_MONTHLY_SALARY,
    RESET_MONTHLY_SALARY
} = actions;

const initState = {
    monthlySalaries: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    salaryDeclarationsAndAttendances: {
        data: [],
    },
    monthlySalary: { _id: null }
};

const MonthlySalaryReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_SALARY_DECLARATIONS_ATTENDANCE:
            return {
                ...state,
                salaryDeclarationsAndAttendances: data
            };
        case FETCH_MONTHLY_SALARIES:
            return {
                ...state,
                monthlySalaries: data
            };
        case RESET_MONTHLY_SALARY:
            return {
                ...state,
                monthlySalary: initState.monthlySalary
            };
        case FETCH_MONTHLY_SALARY:
            return {
                ...state,
                monthlySalary: data
            };
        default:
            return state;
    }
};

export default MonthlySalaryReducer;
